import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MzToastService } from "ng2-materialize";

import { User } from "../../../interfaces/user";
import {
  SubscriptionService,
  Address,
} from "../../../services/subscription/subscription.service";
import { countries } from "./countries";

@Component({
  selector: "app-subscription-address",
  templateUrl: "./subscription-address.component.html",
  styleUrls: ["./subscription-address.component.scss"],
})
export class SubscriptionAddressComponent implements OnInit {
  @Input() user: User;
  @Input() address: Address;

  @Output() addressUpdate = new EventEmitter<Address>();

  countries = countries;
  isSubmitting = false;
  addressForm: FormGroup;
  addressFormErrMsgs = {
    line1: {
      required: "Bitte gib eine Adresse an.",
    },

    postalCode: {
      required: "Bitte gib eine Postleitzahl an.",
    },

    city: {
      required: "Bitte gib eine Postleitzahl an.",
    },

    state: {
      required: "Bitte gib ein Bundesland an.",
    },

    country: {
      required: "Bitte wähle ein Land aus.",
    },
  };

  constructor(
    private readonly ToastService: MzToastService,
    private readonly SubscriptionService: SubscriptionService
  ) {}

  /**
   * Runs when the component is mounted.
   */
  ngOnInit() {
    const { line1, line2, postalCode, city, state, country } = this.address;

    // Initializes the billing address form.
    this.addressForm = new FormGroup({
      line1: new FormControl(line1, Validators.required),
      line2: new FormControl(line2),
      postalCode: new FormControl(postalCode, [Validators.required]),
      city: new FormControl(city, Validators.required),
      state: new FormControl(state, Validators.required),
      country: new FormControl(country, Validators.required),
    });
  }

  /**
   * Submits the billing address form.
   */
  async submitAddressForm() {
    this.isSubmitting = true;

    // Updates the user's billing address.
    const newAddress = await this.SubscriptionService.updateAddress(
      this.addressForm.value
    );

    // Emits the updated billing address to the parent component.
    this.addressUpdate.emit(newAddress);

    this.isSubmitting = false;
    this.ToastService.show(
      "Rechnungsadresse gespeichert!",
      4000,
      "confirm-toast"
    );
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/subscription/subscription-address/subscription-address.component.ts